import type {ReactElement} from 'react';
import {Button, IconPlacement, Size, Type} from '@Components/button';
import {Text, TextSize} from '@Components/text';
import {getAssetUrl} from '@Utils/s3.util';
import {openAddTeamMembersModal} from '@Modals/add-team-members-modal/add-team-members-modal.library';
import type {InviteTeamBannerProps} from '@Components/checkout-flow/components/invite-team-banner/invite-team-banner.types';
import {POST_CHECKOUT_ADD_TEAM_MEMBERS_SOURCE} from '@Components/checkout-flow/checkout-flow.types';
import styles from './invite-team-banner.module.scss';

export function InviteTeamBanner({teamName, onBeforeOpenInvite}: InviteTeamBannerProps): ReactElement {
  const onInviteTeam = (): void => {
    onBeforeOpenInvite();
    openAddTeamMembersModal({source: POST_CHECKOUT_ADD_TEAM_MEMBERS_SOURCE});
  };

  const getContent = (): ReactElement => {
    if (teamName !== '') {
      return (
        <div className={styles.teamContent}>
          <Text val={window.i18next.t('pmwjs_you_are_now_a_part_of')} size={TextSize.SM} className="content-body" />
          <Text val={teamName} size={TextSize.LG} className={styles.teamName} />
          <Text val={window.i18next.t('pmwjs_enjoy_seamless_collaboration_shared_branding_and_marketing_assets_and_more')} size={TextSize.SM} className="content-body" />
        </div>
      );
    }
    return (
      <Button
        size={Size.SMALL}
        type={Type.PREMIUM3}
        text={window.i18next.t('pmwjs_invite_your_team')}
        icon="icon-member-added"
        iconPlacement={IconPlacement.LEFT}
        customClasses={styles.cta}
        onClick={onInviteTeam}
      />
    );
  };

  return (
    <div className={styles.banner}>
      <div className={styles.sideImage}>
        <img src={getAssetUrl('checkout-banner-left.png')} alt="" className={styles.sideImg} />
      </div>
      <div className={styles.backgroundImage}>
        <img src={getAssetUrl('checkout-banner-bg.png')} alt="" className={styles.backgroundImg} />
      </div>
      {getContent()}
      <div className={styles.sideImage}>
        <img src={getAssetUrl('checkout-banner-right.png')} alt="" className={styles.sideImg} />
      </div>
    </div>
  );
}
